export default __webpack_public_path__ + "static/media/thumbnail.c8bfcb26.png";